import React from 'react';
import { LazySection } from './LazySection';
export function VsSection() {
  return <LazySection className="bg-cream !pt-[30px] !pb-[60px] md:!pb-[90px]" data-id="element-410">
      <div className="container-custom" data-id="element-411">
        <div className="bg-white border border-border rounded-[24px] p-8 pb-10 md:px-10 md:pt-11 md:pb-14 max-w-[900px] mx-auto" data-id="element-412">
          <span className="eyebrow block text-center" data-id="element-413">
            Importante antes de seguir
          </span>
          <h3 className="text-[clamp(24px,3.5vw,32px)] mb-2.5 text-center" data-id="element-414">
            Esto NO es una constelación familiar
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-[30px] mt-[30px]" data-id="element-415">
            <div className="flex flex-col" data-id="element-416">
              <h4 className="font-serif text-[17px] mb-4 pb-2.5 border-b border-border font-medium text-red-x" data-id="element-417">
                Constelaciones familiares
              </h4>
              <ul className="list-none flex flex-col gap-1" data-id="element-418">
                {['Trabajo grupal y exposición pública', 'Experiencias intensas sin contención posterior', 'Categorizadas como pseudoterapia por psicólogos reconocidos', 'Dependencia del facilitador', 'Sin base científica verificable'].map((item, i) => <li key={i} className="py-2 pl-[26px] text-[14px] text-ink-soft relative leading-[1.5]" data-id="element-419">
                    <span className="absolute left-0 top-2 text-[13px] font-semibold text-red-x" data-id="element-420">
                      ✕
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col" data-id="element-421">
              <h4 className="font-serif text-[17px] mb-4 pb-2.5 border-b border-border font-medium text-gold-dark" data-id="element-422">
                El Origen de Tus Bloqueos
              </h4>
              <ul className="list-none flex flex-col gap-1" data-id="element-423">
                {['Proceso 100% privado e individual', 'Ritmo propio, con integración guiada', 'Base en epigenética y psicología transgeneracional', 'Herramientas que hacés sola, para siempre tuyas', 'Estudios científicos citables (Emory, Mount Sinai)'].map((item, i) => <li key={i} className="py-2 pl-[26px] text-[14px] text-ink-soft relative leading-[1.5]" data-id="element-424">
                    <span className="absolute left-0 top-2 text-[13px] font-semibold text-green-check" data-id="element-425">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </LazySection>;
}